// Vuelette Logo — Variant G1 (Editorial masthead — Primary).
//
// Specifikation 1:1 från vuelette-logos-v2.html, top pick #1:
//   • Wordmark: VUELETTE all-caps
//   • Font: Fraunces 300
//   • Letter-spacing: 18px (vid 80px font-size = ~0.225em)
//   • Rosé dot: cx=612, cy=72, r=6 i en 700×110 viewBox (baseline-aligned)
//
// Implementerad som inline SVG istället för CSS letter-spacing, eftersom
// CSS letter-spacing skapar trailing-tracking efter sista bokstaven (E)
// vilket gör att dotten hamnar för långt bort. I SVG kan vi placera
// dot:en precis där den ska — direkt efter E utan trailing-gap, baseline-
// aligned (inte upphöjd som A1).
//
// Detta är PRIMARY-loggan som används i nav, login, app, email-headers
// och alla andra brand-touchpoints.

interface LogoProps {
  // Visuell storlek. Default 'md'.
  size?: 'sm' | 'md' | 'lg' | 'xl';
  // Tagless = ingen rosé-prick (för vissa kompakta kontexter). Default false.
  hideDot?: boolean;
  // Färg på wordmark. Default 'currentColor' så den ärver från parent.
  color?: string;
  // Klassnamn på wrapper.
  className?: string;
}

// Per-storlek: höjd i pixel som SVG renderas i. Bredden räknas ut från viewBox.
const SIZE_MAP = {
  sm: 20,
  md: 26,
  lg: 40,
  xl: 64,
} as const;

// SVG-konstanter — exakt samma som vuelette-logos-v2.html G1.
// 700×110 viewBox, text vid x=340 y=78 (center-aligned), circle vid 612/72 r=6.
// Med hideDot använder vi en annorlunda viewBox utan plats för circle.
const VIEWBOX = '0 0 700 110';
const VIEWBOX_NO_DOT = '0 0 640 110';

export function Logo({
  size = 'md',
  hideDot = false,
  color = 'currentColor',
  className = '',
}: LogoProps) {
  const heightPx = SIZE_MAP[size];
  const viewBox = hideDot ? VIEWBOX_NO_DOT : VIEWBOX;
  // Bredd i pixel = viewBox-aspect × height
  const viewBoxWidth = hideDot ? 640 : 700;
  const widthPx = Math.round((viewBoxWidth / 110) * heightPx);

  return (
    <svg
      className={`vl-logo ${className}`}
      viewBox={viewBox}
      width={widthPx}
      height={heightPx}
      role="img"
      aria-label="Vuelette"
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <text
        x={hideDot ? 320 : 340}
        y="78"
        textAnchor="middle"
        fontFamily="Fraunces, Georgia, serif"
        fontWeight={300}
        fontSize="80"
        letterSpacing="18"
        fill={color}
      >
        VUELETTE
      </text>
      {!hideDot && (
        <circle cx="612" cy="72" r="6" fill="#e0b3a3" />
      )}
    </svg>
  );
}
